'use strict';
import React from 'react';
import flux from 'utils/flux';
import Thumb from 'components/thumb';

var LicensingListingItem = React.createClass({

    displayName: 'LicensingListingItem',

    propTypes: {
        item: React.PropTypes.object
    },

    render() {
        const request   = this.props.item.toJS();
        const { media } = request;
        const MICode    = media.meta && media.meta.find( meta => 'MICode' === meta.key );
        const master    = media.files && media.files.find( file => 'master' === file.key );
        const duration  = master && master.meta && master.meta.find && master.meta.find( meta => 'Duration' === meta.name );

        return (
            <div className="listing__item">
                <Thumb className="item__preview" media={this.props.item.get('media')}/>
                <div className="item__info">
                    <div className="info__description">
                        <div className="description__title">
                            {media.title}
                            {duration && ` ${duration.value}`}
                            <div className="info__meta">
                                {MICode && <span className="meta__id">{MICode.value}</span>}
                                {master && false/*<span className="meta__file">{item.master.mime} / {item.master.fileSize} / {item.master.size}px / {item.master.dpi} dpi</span>*/}
                            </div>
                        </div>
                        <div className="description__status">
                            <div className="status__meta">
                                <span className="meta__prefix">
                                    {flux.t('license_status')}:
                                </span>
                                &nbsp;
                                <span style={{color: request.color}}>
                                    {request.status}
                                </span>
                            </div>
                            <div className="status__date">
                                <span className="date__prefix">
                                    {flux.t('license_submitted_on')}
                                </span>
                                &nbsp;
                                {request.date}
                            </div>
                        </div>
                    </div>
                    <hr className="grey" />
                </div>
                <p className="item__comment">
                    {request.comment}
                </p>
            </div>
        );
    }
});

module.exports = LicensingListingItem;



// WEBPACK FOOTER //
// ./app/pages/licensing/requests/requestsListingItem.jsx